import { Seo } from '@/components/common/Seo';
import { BrandShowcase } from '@/components/home/BrandShowcase';
import { CategoryGrid } from '@/components/home/CategoryGrid';
import { ContactBlock } from '@/components/home/ContactBlock';
import { FaqSection } from '@/components/home/FaqSection';
import { FeaturedProducts } from '@/components/home/FeaturedProducts';
import { FinalCta } from '@/components/home/FinalCta';
import { Hero } from '@/components/home/Hero';
import { HowToBuy } from '@/components/home/HowToBuy';
import { PetMatchQuiz } from '@/components/home/PetMatchQuiz';
import { TrustStrip } from '@/components/home/TrustStrip';

export default function HomePage() {
  return (
    <>
      <Seo
        path="/"
        description="Rações das melhores marcas para cães e gatos em São Paulo. Monte seu pedido no site e finalize pelo WhatsApp com entrega rápida."
      />

      <Hero />
      <TrustStrip />
      <CategoryGrid />
      <FeaturedProducts />
      <PetMatchQuiz />
      <BrandShowcase />
      <HowToBuy />
      <ContactBlock />
      <FaqSection />
      <FinalCta />
    </>
  );
}
